export { default as Favorite } from './Favorite'
